module.exports = __webpack_public_path__ + "static/media/logo_rsw.f96c0771.png";